import { render, staticRenderFns } from "./ReturnPayment.vue?vue&type=template&id=324bf6ae&"
import script from "./ReturnPayment.vue?vue&type=script&lang=js&"
export * from "./ReturnPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports